function About() {
    return (
        <div>
            <h1 className="text-6xl mb-4"> Github Discover</h1>
            <p className="mb-4 text-2xl font-light">
                A React App To Search Github Users And See Their Details
            </p>
            <p className="text-lg text-gray-400"> Version : <span className="text-white" > 1.0.0 </span> </p>
        </div>
    )
}

export default About
